<div class="cm-instance-details">
    <header>
        <h1>Instance</h1>
        <code class="cm-instance-name">{{ $instanceName() }}</code>
    </header>

    @if ($loading()) {
        <p class="cm-muted">Loading history…</p>
    } @else if ($events().length === 0) {
        <p class="cm-muted">No recorded events for this instance.</p>
    } @else {
        <ol class="cm-timeline">
            @for (event of $events(); track $index) {
                <li class="cm-event cm-src-{{ event.source }}">
                    <span class="cm-chip cm-{{ tone(event) }}">{{ event.eventType }}</span>
                    <span class="cm-source">{{ event.source }}</span>
                    <span class="cm-detail">
                        {{ detail(event) }}
                        @if (event.source === "task" && event.jobLegacyId) {
                            <a class="cm-link" [routerLink]="['/jobs', event.jobLegacyId]">job {{ event.jobLegacyId }}</a>
                        }
                        @if (event.durationSeconds) {
                            <span class="cm-dur">{{ event.durationSeconds }}s</span>
                        }
                    </span>
                    <time class="cm-when" [attr.datetime]="event.observedAt">{{ event.observedAt | date: "short" }}</time>
                </li>
            }
        </ol>
    }
</div>
